export const pushToDataLayer = (data) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(data);
};

export const trackApplyButton = (buttonLocation) => {
  pushToDataLayer({
    event: "apply_button",
    buttonLocation,
  });
};

export const trackGenerateLead = ({ firstName, lastName, email, phone, formLocation, formType }) => {
  pushToDataLayer({
    event: "generate_lead",
    firstName,
    lastName,
    email,
    phone,
    formLocation,
    formType,
  });
};
